import type RoboticMowerCommandActionType from '~/ducks/robotic-mower-command/robotic-mower-command-action-type';
import RoboticMowerCommand from '~/ducks/robotic-mower-command/robotic-mower-command';
import BFFAPI from './utils/BFFAPI';

export type SendCommandResponse = Array<{
  iprId: AssetId;
  success: boolean;
  followupNotRequired?: boolean;
  missionId: number | null;
}>;

class RoboticMowerAPI extends BFFAPI {
  sendCommandToRoboticMowers = (
    iprIdList: AssetId[],
    commandType: RoboticMowerCommand,
    commandActionType: RoboticMowerCommandActionType,
    missionId: number | null,
    commandTimerInMinutes?: number
  ): Promise<SendCommandResponse> => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}/command`, {
      iprIdList,
      commandType,
      commandActionType,
      missionId,
      commandTimerInMinutes,
    });
    return this.fetch(req);
  };
}

export default new RoboticMowerAPI('/fleet/secure/machines/robotic');
